import { render, staticRenderFns } from "./edit-message.vue?vue&type=template&id=07e957a4&scoped=true"
import script from "./edit-message.vue?vue&type=script&lang=ts"
export * from "./edit-message.vue?vue&type=script&lang=ts"
import style0 from "./edit-message.vue?vue&type=style&index=0&id=07e957a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e957a4",
  null
  
)

export default component.exports